<template>
  <div>
    <multiselect
      v-model="selectedUser"
      class="mb-3"
      :options="users"
      :custom-label="customLabel"
      placeholder="ユーザ名で検索"
      label="name"
      track-by="name"
      :loading="isSearching"
      @search-change="searchUsers"
    >
      <span slot="noResult">ユーザが見つかりません</span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "SearchUsers",
  components: { Multiselect },
  props: {
    selected: {
      type: Object,
      default: null,
    },
    apiFields: {
      type: Array,
      default: () => ["id", "auth0_user_id", "name", "email"],
    },
    filter: {
      type: Function,
      default: () => true,
    },
  },
  data() {
    return {
      selectedUser: this.selected,
      isSearching: false,
      toggleDropdown: false,
      users: [],
      sorterValue: { column: "updated_at", asc: false },
    };
  },
  computed: {
    sort() {
      return this.sorterValue.asc ? this.sorterValue.column : `-${this.sorterValue.column}`;
    },
  },
  watch: {
    selectedUser() {
      this.$emit("update:selected", Object.assign({}, this.selectedUser));
    },
  },
  async created() {
    await this.searchUsers();
  },
  methods: {
    customLabel({ id, name }) {
      return `[${id}] ${name}`;
    },
    async searchUsers(query) {
      if (this.isSearching) return;

      this.isSearching = true;
      const req_params = {
        query: query,
        fields: this.apiFields.concat(["id"]).join(","),
        sort: this.sort,
      };
      const response = await this.$axios.get(`/api/v2/core/admin/users`, { params: req_params }).catch(() => (this.isSearching = false));
      this.users = response.data.filter(this.filter);
      this.isSearching = false;
    },
  },
};
</script>
